import { QueryResult } from "@/api/utils/types"
import {
  IPsrCustomerSettings,
  IPsrPriorityService,
  IPsrVulnerability,
} from "@/models/psr/psr.types"
import { PsrVulnerabilityParser } from "@/models/psr/vulnerability/psrVulnerability.parser"
import { useQuery } from "@/api/utils/useQuery"
import { BackofficeRestQueries } from "@/api/backofficeRest/queries"
import {
  VulnerabilityCategoriesResponse,
  ServicesResponse,
} from "@/api/backofficeRest/generated/model"
import {
  IPsrCustomerSettingsRaw,
  PsrCustomerSettingsParser,
} from "@/models/psr/customerSettings/psrCustomerSettings.parser"
import { PsrPriorityServiceParser } from "@/models/psr/priorityService/psrPriorityService.parser"
import { PsrMutator } from "@/mutators/psr/PsrMutator"

class PsrServiceClass {
  getVulnerabilities(): QueryResult<IPsrVulnerability[]> {
    return useQuery({
      ...BackofficeRestQueries.psr.categories,
      useRawResponse: true,
      placeholderData: [],
      parserFn: (rawData: VulnerabilityCategoriesResponse[]) =>
        (rawData ?? []).flatMap((category) =>
          category.vulnerabilities.map((v) =>
            PsrVulnerabilityParser.toDomain(v),
          ),
        ),
    })
  }

  getCustomerSettings(customerId: number): QueryResult<IPsrCustomerSettings> {
    return useQuery({
      ...BackofficeRestQueries.psr.customerSettings(customerId),
      placeholderData: {
        customerServices: [],
        customerVulnerabilities: [],
      },
      useRawResponse: true,
      parserFn: (rawData: IPsrCustomerSettingsRaw) =>
        PsrCustomerSettingsParser.toDomain(rawData),
    })
  }

  getServicesByVulnerabilityIds(
    ids: string | null,
  ): QueryResult<Array<IPsrPriorityService>> {
    return useQuery({
      ...BackofficeRestQueries.psr.servicesByVulnerabilityIds(ids ?? ""),
      useRawResponse: true,
      placeholderData: [],
      parserFn: (rawData: ServicesResponse[]) =>
        (rawData ?? []).map((service) =>
          PsrPriorityServiceParser.toDomain(service),
        ),
      enabled: !!ids,
    })
  }

  storeVulnerabilitiesAndAssociatedServices() {
    return PsrMutator.storeVulnerabilitiesAndAssociatedServices()
  }
}

export const PsrService = new PsrServiceClass()
